import Vue from 'vue'
import VueCharts from 'vue-chartjs'
import { HorizontalBar } from 'vue-chartjs'

export default {
  name: 'BarChart',
  extends: HorizontalBar,
  props: {
    chartType: {
      type: String,
      required: false
    },
    chartName: {
      type: String,
      required: false
    },
    chartData: {
      type: Object,
      required: false,
      default: null
    }
  },
  mounted() {
    // let data = {
    //   labels: ['January', 'February'],
    //   datasets: [{
    //     label: 'GitHub Commits',
    //     backgroundColor: '#f87979',
    //     data: [40, 20]
    //   }]
    // }
    // this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: true })
    // this.renderChart(this.data, { responsive: true, maintainAspectRatio: true })
  },

  methods: {
    render() {
      this.renderChart(this.chartData, { responsive: true, maintainAspectRatio: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/Homepage/components/Chart/BarChart.js